module.exports = __webpack_public_path__ + "img/h5.caad37bb.png";